<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>
      Proton Therapy Contacts
    </ion-title>
    <img alt="PSI logo" slot="end" class="titleicon" [src]="assets + '/psi_logo.svg'" width="80px" routerLink="/home" />
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <!--Contact info of the secretary's office of CPT-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Secretary's office</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <a title="Phone number of Secretary's office" href="tel:+41563103524">
        <ion-chip color="dark">
          <ion-icon name="call"></ion-icon>
          <ion-label>+41 56 310 35 24</ion-label>
        </ion-chip>
      </a>
      <a title="Fax number of Secretary's office">
        <ion-chip color="dark">
          <ion-icon name="print"></ion-icon>
          <ion-label>+41 56 310 35 15</ion-label>
        </ion-chip>
      </a>
      <a title="E-Mail of Secretary's office" href="#"
        (click)="openEmail('protonentherapie@psi.ch')">
        <ion-chip color="dark">
          <ion-icon name="mail"></ion-icon>
          <ion-label>protonentherapie@psi.ch</ion-label>
        </ion-chip>
      </a>
    </ion-card-content>
  </ion-card>

  <!--Contact info of the doc-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>Head and Chairman, Center for Proton Therapy</ion-card-title>
      <ion-card-subtitle>Prof. Dr. med. Damien Charles Weber</ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <a title="Phone number of Prof. Dr. med. Damien Charles Weber" href="tel:+41563105828">
        <ion-chip color="dark">
          <ion-icon name="call"></ion-icon>
          <ion-label>+41 56 310 58 28</ion-label>
        </ion-chip>
      </a>
      <a title="E-Mail of Prof. Dr. med. Damien Charles Weber" href="#"
        (click)="openEmail('damien.weber@psi.ch')">
        <ion-chip color="dark">
          <ion-icon name="mail"></ion-icon>
          <ion-label>damien.weber@psi.ch</ion-label>
        </ion-chip>
      </a>
    </ion-card-content>

    <!--Contacts of the personal assistant-->
    <ion-card-header>
      <ion-card-subtitle>Ariane Hallwachs <small>(Personal Assistant)</small></ion-card-subtitle>
    </ion-card-header>
    <ion-card-content>
      <a title="Phone number of Ariane Hallwachs" href="tel:+41563105857">
        <ion-chip color="dark">
          <ion-icon name="call"></ion-icon>
          <ion-label>+41 56 310 58 57</ion-label>
        </ion-chip>
      </a>
      <a title="E-Mail of Ariane Hallwachs" href="#"
        (click)="openEmail('ariane.hallwachs@psi.ch')">
        <ion-chip size="small" color="dark">
          <ion-icon name="mail"></ion-icon>
          <ion-label>ariane.hallwachs@psi.ch</ion-label>
        </ion-chip>
      </a>
    </ion-card-content>
  </ion-card>

  <!--Link to CPT Homepage-->
  <ion-card>
    <ion-card-header>
      <ion-card-title>For more informations:</ion-card-title>
    </ion-card-header>
    <ion-card-content>
      <a title="Link to the Foodtruck schedule" href="https://www.psi.ch/de/protontherapy" target="_blank"
        rel="noopener noreferrer">
        <ion-button shape="round" color="dark">
          Homepage - Proton Therapy
          <ion-icon slot="start" name="link"></ion-icon>
        </ion-button>
      </a><br>
    </ion-card-content>
  </ion-card>

</ion-content>
